import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { StdAttendanceDialogBoxComponent } from '../std-attendance-dialog-box/std-attendance-dialog-box.component';
@Component({
  selector: 'app-student-attendance',
  templateUrl: './student-attendance.component.html',
  styleUrls: ['./student-attendance.component.scss']
})
export class StudentAttendanceComponent implements OnInit {
  APIService: string;
  AttendanceForm: FormGroup;
  SessionFilterList: any;
  sessionList: any;
  filteredListFcCode: any;
  fcCodeList: any;
  BranchList: any;
  filteredListBranch: any;
  filteredListExam: any;
  examList: any;
  selectDropdown: any;
  filterlist: any;
  childrenData: any;
  dataSource: any;
  filteredCourseList: any;
  courseList: any;
  filteredCollegeList: any;
  collegeList: any;
  filteredListExamSub: any;
  examSubList: any;
  AtdArray: FormArray;
  sessionId: any;
  CoCode: any;
  CgCode: any;
  atdTbl = false;
  AtdTable = [];
  submitpayload: any;
  errMsg: any;
  currentDate: Date;
  formattedDate: string;
  dialogRef: MatDialogRef<any>;
  attendanceList: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,private datePipe: DatePipe) {
    this.APIService = environment.serviceUrl;
  }

  formatDate() {
    const currentDate = new Date();
    const formattedDate = this.datePipe.transform(currentDate, 'dd/MM/yyyy');
    return formattedDate;
  }

  ngOnInit(): void {
   
    this.atdTbl = false;
    this.formattedDate = this.formatDate();
    this.getStdAtd();
  }

  getStdAtd(){
    this.spinner.show();
    const payload = {};
    payload['Id'] = '';
    payload['SearchString'] = '';
    payload['PageSize'] = '';
    payload['PageNumber'] = '';
    this.umsService.searchStudentAttendance(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.attendanceList = res.data
      }
    })
  }

  
  addnewrecord() {

    const dialogRef = this.dialog.open(StdAttendanceDialogBoxComponent, {
      width: '90vh',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getStdAtd();
      // this.StateSearchForm.controls['SearchString'].setValue('');
    });
  }
  editData(k) {
    const dialogRef = this.dialog.open(StdAttendanceDialogBoxComponent, {
      width: '90vh',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
      this. getStdAtd();
      // this.StateSearchForm.controls['SearchString'].setValue('');
    });
  }

  deleteData(k){
    const dialogRef = this.dialog.open(StdAttendanceDialogBoxComponent, {
      width: '90vh',
      data: { selected: k, key: "Delete" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
      this. getStdAtd();
      // this.StateSearchForm.controls['SearchString'].setValue('');
    });
  }

  // editData(data){
  //   const payload = {};
  //   payload['Id'] = data.Id;
  //   payload['SearchString'] = '';
  //   payload['PageSize'] = '';
  //   payload['PageNumber'] = '';
  //   this.umsService.searchStudentAttendance(payload).subscribe(res => {
  //     this.spinner.hide();
  //     if (res.status) {
  //       // this.attendanceList = res.data
  //     }
  //   })
  // }

 
}
